import React, { useState, useEffect } from 'react';
import { Building, House, Factory } from 'lucide-react';

import './style.css';

const AddressSearchProgressSecondaryConfirmation = ({
    addressSearchModelingTracker,
    secondaryConfirmationInfo,
    setSecondaryConfirmationInfo
}) => {

    const [propertyTypeSelection, setPropertyTypeSelection] = useState(null);
    const [continueAnalysisConfirmation, setContinueAnalysisConfirmation] = useState(false);

    // useEffect to set the secondaryConfirmationInfo as selection and confirmation change
    useEffect(() => {

        // Return if the property type selection is null
        if (propertyTypeSelection === null) {
            return;
        }

        if ((propertyTypeSelection.type === "single_family") || (propertyTypeSelection && continueAnalysisConfirmation)) {
            // Set the secondary confirmation info
            setSecondaryConfirmationInfo({
                ...secondaryConfirmationInfo,
                propertyType: propertyTypeSelection,
                continueWithAnalysis: true
            });
        }
    }, [propertyTypeSelection, continueAnalysisConfirmation]);

    const PROPERTY_TYPES = [
        { type: "single_family", text: "Single-Family Home", icon: <House />, disclaimer: null },
        { type: "apartment", text: "Apartment", icon: <Building />, disclaimer: "While Quoll is designed for single-family homes, renters, landlords and members of the HOA can gain value from running  the analysis! Given the complexities and layout of multi-family buildings, some of the recommendations may not make sense for a single apartment unit." },
        { type: "business_other", text: "Business / Other", icon: <Factory />, disclaimer: "Commercial/Retail and Industrial property attributes can be complicated. While our models are currently designed primarily for single family homes, we can still provide valuable risk insights for your business property." }
    ];

    // const help_us_understand_text = "Oops, looks like this might not be a single family home. To help ensure we get you the best analysis,  please confirm whether this property is a..."
    const help_us_understand_fillter = "is unsure if this is a single family home"

    let propertyTypeSelectionSentenceFiller = help_us_understand_fillter
    if (addressSearchModelingTracker.secondaryConfirmationReason === 'not-residential') {
        propertyTypeSelectionSentenceFiller = "thinks this is not a residential property"
    }

    const help_us_understand_text = `Hmmm,  our system ${propertyTypeSelectionSentenceFiller}. To help ensure we get you the best analysis, can you confirm whether this property is a...`

    return (
        <div className='address-search-progress-secondary-confirmation'>
            {propertyTypeSelection === null && (
                <>
                    <p className='text-align-center'>{help_us_understand_text}</p>
                    <div className='address-search-progress-secondary-confirmation-property-types'>
                        {PROPERTY_TYPES.map((option) => (
                            <button
                                key={option.type}
                                className='address-search-progress-secondary-confirmation-property-type-button'
                                onClick={() => setPropertyTypeSelection(option)}
                            >
                                <div className='address-search-progress-secondary-confirmation-property-type-icon'>
                                    {option.icon}
                                </div>
                                <span>{option.text}</span>
                            </button>
                        ))}
                    </div>
                </>
            )}
            {propertyTypeSelection !== null && (
                <>
                    <p className='text-align-center'>{propertyTypeSelection.disclaimer}</p>
                    <div className='address-search-progress-secondary-confirmation-property-types'>
                        <button
                            className='address-search-progress-secondary-confirmation-property-type-button back'
                            onClick={() => setPropertyTypeSelection(null)}
                        >
                            <span>Change Property Type</span>
                        </button>
                        <button
                            className='address-search-progress-secondary-confirmation-property-type-button confirmation'
                            onClick={() => setContinueAnalysisConfirmation(true)}
                        >
                            <span>See Analysis Anyways</span>
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default AddressSearchProgressSecondaryConfirmation;